import { ViewOpts } from '@play-co/timestep-core/ui';
import { FlexBoxView } from '@play-co/timestep-core/flexbox';
import i18n from 'src/lib/i18n/i18n';
import { BuddiesRibbon } from 'src/game/buddies/components/BuddiesRibbon';
import { Match2RewardsPanel } from 'src/game/minigame/match2-timestep/components/Match2RewardsPanel';
import { buddiesPartyJoinRewards } from 'src/replicant/buddies/buddies.ruleset';

type BuddiesJoinRewardsOpts = ViewOpts & {
  width: number;
};

export class BuddiesJoinRewards extends FlexBoxView {
  constructor(opts: BuddiesJoinRewardsOpts) {
    super({
      ...opts,
      flex: {
        width: opts.width,
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 10,
        marginBottom: 15,
      },
    });

    const ribbon = new BuddiesRibbon({
      superview: this,
    });
    ribbon.setText(i18n('match2.buddies.incomingInvitePopup.rewards'));

    const rewardsPanel = new Match2RewardsPanel({
      superview: this,
      width: opts.width - 60,
      height: 140,
      itemSize: 90,
      centerOnOrigin: false,
    });
    rewardsPanel.setRewards(buddiesPartyJoinRewards);
  }
}
